<template>
  <div class="file-uploader">
    <form
      id="upload-form"
      class="upload-form"
      enctype="multipart/form-data"
      novalidate
      v-if="isInitial || isSaving"
    >
      <input
        class="input-file"
        id="file-upload"
        type="file"
        name="file-upload"
        :disabled="isSaving"
        @change="filesAdded"
        accept="text/plain, application/pdf, application/msword, image/*, application/zip, application/vnd.ms-excel, application/json, text/*, application/rtf"
      >
      <label for="file-upload" :class="{'danger': isFail}">
        <!-- Upload? -->
        <!-- <font-awesome-icon :icon="['fas', 'file-upload']"/> -->
        <i class="fas fa-file-upload"></i>
        <span class="feedback" v-if="isInitial">Drag file here or click to choose</span>
        <span class="feedback" v-if="isSaving">Uploading files... {{ uploadProgress }}</span>
        <!-- <span class="feedback">{{ uploadProgress }}</span> -->
        <span class="feedback danger" v-if="isFail">Well, that didn't work..</span>
      </label>
    </form>
  </div>
</template>

<script>
import firebase from "firebase/app";
// eslint-disable-next-line
import storage from "firebase/storage";

const STATUS = {
  initial: 0,
  fail: 1
};

export default {
  name: "FileUploader",
  props: ["userId", "board_id"],
  data() {
    return {
      uploadError: null,
      currentStatus: null,
      isSaving: false,
      downloadFile: null,
      uploadProgress: null
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS.initial;
    },
    isFail() {
      return this.currentStatus === STATUS.fail;
    }
  },
  methods: {
    reset() {
      this.isSaving = false;
      this.currentStatus = STATUS.initial;
      this.uploadError = null;
    },

    filesAdded(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.save(file);
    },

    formmatFilename(fileName) {
      const reg = /\s/g;
      const nameNoSpaces = fileName.replace(reg, "-");
      const stampedFilename = Date.now() + "-" + nameNoSpaces;
      return stampedFilename;
    },

    save(file) {
      this.isSaving = true;

      const metadata = {
        contentType: file.type
      };
      const stampedFilename = this.formmatFilename(file.name);
      const BUCKET = "/board_files/" + stampedFilename;
      const storageRef = firebase.storage().ref();

      const uploadTask = storageRef.child(BUCKET).put(file, metadata);

      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED,
        snapshot => {
          let progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          // window.console.log("upload is " + progress + "% done.");
          this.uploadProgress = progress + "% done.";
          switch (snapshot.state) {
            case firebase.storage.TaskState.RUNNING:
              window.console.log("Upload is running");
              break;
          }
        },
        err => {
          window.console.log("uploading error: ", err);
          this.currentStatus = STATUS.fail;
        },
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            this.downloadFile = {
              downloadURL: downloadURL,
              userId: this.userId,
              name: stampedFilename,
              originalFilename: file.name
            };
            this.$emit("newFileUploaded", this.downloadFile);
            this.reset();
          });
        }
      );
    }
  },
  mounted() {
    this.reset();
  }
};
</script>

<style lang="scss" scoped>
.file-uploader {
  // background-color: #7ab8cc;
  color: white;
  text-align: center;
  font-size: 1.25rem;

  .upload-form {
    text-align: center;
    input[type="file"] {
      // HIDE IT
      opacity: 0;
      border: 1px solid black;
      padding: 1rem;
      position: absolute !important;
      left: 50%;
      top: 162px;
      margin-right: -50%;
      transform: translateX(-50%);
      cursor: pointer;
      width: 225px;
      height: 40px;
    } // input[type=file]
    [type="file"] + label {
      &.danger {
        background-color: rgb(133, 68, 68);
      } // &.danger

      max-width: 250px;
      background-color: #6b5a75;
      border-radius: 5px;
      display: inline-block;
      padding: 1rem;
      text-transform: uppercase;
      font-family: inherit;
      font-size: 1rem;
      i {
        font-size: 1.5rem;
      }
      transition: background-color 0.3s;
      .feedback {
        text-transform: none;
        display: block;
        padding-top: 1rem;
      }
    } // [type="file"] + label
    [type="file"]:focus + label,
    [type="file"] + label:hover {
      background-color: grey;
    }
    [type="file"]:focus + label {
      outline: 1px dotted black;
    }
  } // .upload-form
} // .file-uploader
</style>
